import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import { useAuth, useMembersContext, useInfo } from '../../context';
import { Theme } from '../../config';
import { AdminNavbar, Alert, PoliciesList } from '..';

export const PoliciesPage: React.FC = React.memo(() => {
    const { session, userInfo, getUserInfo, getUserInfoResponse } = useAuth();
    const {
        policies,
        getPolicies,
        getPoliciesResponse,
        getEmployeePolicies,
        getEmployeePoliciesResponse
    } = useInfo();

    const { employeeMembers } = useMembersContext();

    React.useEffect(() => {
        session.Role === 2 && !userInfo && getUserInfo();
    }, [getUserInfo, userInfo, session.Role]);

    React.useEffect(() => {
        session.Role === 2 && getPolicies(userInfo ? userInfo.Company : 'PRISPEK');
    }, [getPolicies, userInfo, session.Role]);

    return (
        <>
            <Alert
                closeHandler={getUserInfoResponse.closeAlert}
                {...getUserInfoResponse.alert}
            />
            <Alert
                closeHandler={getPoliciesResponse.closeAlert}
                {...getPoliciesResponse.alert}
            />
            <AdminNavbar policies />
            <Container
                component='main'
                maxWidth='md'
                sx={{ pt: '6rem', pb: '2rem' }}
            >
                <Stack
                    direction='row'
                    alignItems='flex-end'
                    justifyContent='space-between'
                >
                    {(session.Role === 1 || session.Role === 0) && (
                        <TextField
                            select
                            label='Select employee'
                            sx={{ width: '15rem' }}
                            onChange={e => {
                                getEmployeePolicies(JSON.parse(e.target.value));
                            }}
                        >
                            {employeeMembers.map(employee => (
                                <MenuItem
                                    key={employee.Guid}
                                    value={JSON.stringify(employee)}
                                >
                                    {employee.Name} {employee.Surname}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                    {policies.length > 0 && (
                        <Box p='0.5rem 1rem' sx={{ background: Theme.lightYellow }}>
                            <Typography variant='subtitle1' component='sub'>
                                {policies.reduce(
                                    (accumulator, policy) =>
                                        (policy.Policies
                                            ? policy.Policies.reduce(
                                                  (acc, subPolicy) =>
                                                      subPolicy.Guid === undefined
                                                          ? acc
                                                          : acc + 1,
                                                  0
                                              )
                                            : 0) +
                                        (policy.Guid === undefined
                                            ? accumulator
                                            : accumulator + 1),
                                    0
                                )}
                                /
                                {policies.reduce(
                                    (accumulator, policy) =>
                                        (policy.Policies
                                            ? policy.Policies.reduce(
                                                  acc => acc + 1,
                                                  0
                                              )
                                            : 0) +
                                        (policy.Variant === 'item'
                                            ? accumulator + 1
                                            : accumulator),
                                    0
                                )}{' '}
                                read
                            </Typography>
                        </Box>
                    )}
                </Stack>
                <List
                    component='section'
                    sx={{
                        backgroundColor: '#efefef',
                        padding: 0,
                        width: '100%'
                    }}
                    disablePadding
                >
                    {session.Role === 2 ? (
                        getPoliciesResponse.loading ? (
                            <CircularProgress />
                        ) : (
                            <PoliciesList
                                policies={policies}
                                company={userInfo ? userInfo.Company : 'PRISPEK'}
                            />
                        )
                    ) : policies.length > 0 ? (
                        getEmployeePoliciesResponse.loading ? (
                            <LinearProgress />
                        ) : (
                            <PoliciesList
                                policies={policies}
                                company={userInfo ? userInfo.Company : 'PRISPEK'}
                            />
                        )
                    ) : (
                        <Stack
                            mt='2rem'
                            alignItems='center'
                            width='100%'
                            sx={{ background: Theme.background }}
                        >
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 800 }}>
                                Select a member
                            </h1>
                        </Stack>
                    )}
                </List>
            </Container>
        </>
    );
});
